export default __webpack_public_path__ + "static/media/Audio_2021_HTB600_EGEBGNGAGJ_Gallery_Image_4_210202.ae1b3f35.jpg";